// Returns `ms` while the tab is visible and the poll is fresh, else 0.
// RTK Query 1.9 treats pollingInterval 0 as "off". Built because the drafts
// polls ran every 60s for 50–93 minutes in tabs nobody was looking at, and
// each poll went through trackEvent into user_events.
import { useEffect, useState } from 'react';

const isVisible = () =>
  typeof document === 'undefined' || document.visibilityState !== 'hidden';

export default function usePollingInterval(ms, maxMs = 10 * 60 * 1000) {
  const [visible, setVisible] = useState(isVisible());
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    const onChange = () => setVisible(isVisible());
    document.addEventListener('visibilitychange', onChange);
    return () => document.removeEventListener('visibilitychange', onChange);
  }, []);

  // Restart the cap every time the owner comes back to the tab.
  useEffect(() => {
    if (!visible) return;
    setExpired(false);
    const t = setTimeout(() => setExpired(true), maxMs);
    return () => clearTimeout(t);
  }, [visible, maxMs]);

  return visible && !expired ? ms : 0;
}